import type { ThemeConfig } from 'antd'

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#164e87',
    colorSuccess: '#1dbf23',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#164e87',
    borderRadius: 6,
    wireframe: false,
  },
  components: {
    Button: {
      borderRadius: 6,
    },
    Input: {
      borderRadius: 6,
    },
    Card: {
      borderRadius: 8,
    },
  },
}
